import { Box, FormHelperText, Stack, TextField } from "@mui/material";
import React, { useEffect, useRef } from "react";

import { AnimatedWebcam } from "components/common/AnimatedWebcam/AnimatedWebcam";
import { MAX_DETECTOR_NAME_LENGTH, MAX_DETECTOR_NAME_LENGTH_ERROR } from "config/constants";
import { Typography } from "new-components/typography/Typography";

import { DEFAULT_DETECTOR_QUERY_EXAMPLE } from "../constants";

type ThirdStepProps = {
  queryText: string;
  setQueryText: (queryText: string) => void;
  setIsInvalid: (isInvalid: boolean) => void;
};

export function ThirdStep({ setQueryText, queryText, setIsInvalid }: ThirdStepProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const hasPrefilledText = queryText === DEFAULT_DETECTOR_QUERY_EXAMPLE;
  const error = queryText.length > MAX_DETECTOR_NAME_LENGTH ? MAX_DETECTOR_NAME_LENGTH_ERROR : null;

  useEffect(() => {
    setIsInvalid(error !== null);
  }, [error, setIsInvalid]);

  const handleClick = () => {
    if (hasPrefilledText) {
      inputRef.current?.select();
    }
  };

  return (
    <Stack direction="row" spacing="25px" className="w-full h-[188px]">
      <AnimatedWebcam
        className="w-[250px] h-[188px] flex-shrink-0"
        height={188}
        audio={false}
        screenshotFormat="image/jpeg"
      />

      <Box className="bg-white text-[32px] border-none p-[15px] w-full">
        <Typography fontWeight="medium" className="text-neutral-dark">
          YOUR QUESTION:
        </Typography>
        <TextField
          inputRef={inputRef}
          className="w-full"
          helperText={
            <FormHelperText
              error
              className="truncate text-base m-0 mt-3"
              sx={{
                ".MuiFormHelperText-contained": {
                  marginLeft: 0,
                },
                ".MuiFormHelperText-root": {
                  marginLeft: 0,
                },
              }}
            >
              {error}
            </FormHelperText>
          }
          multiline
          rows={3}
          value={queryText}
          placeholder={DEFAULT_DETECTOR_QUERY_EXAMPLE}
          autoFocus
          onChange={(event) => {
            const text = event.currentTarget.value;
            setQueryText(text);
          }}
          onClick={handleClick}
          sx={{
            "& .MuiInputBase-input::placeholder": {
              fontWeight: 500,
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: "none",
              },
            },
            "& .MuiInputBase-root": {
              fontSize: "32px",
              padding: 0,
            },
          }}
        />
      </Box>
    </Stack>
  );
}
